import { getSupabaseClient } from './supabase.client.js';

/**
 * Repositorio de bloqueos de disponibilidad para el panel de staff (Fase 1).
 * Habla con Supabase SOLO a través del cliente anon de navegador
 * (supabase.client.js); el acceso lo enforcea RLS (`blocks_all_staff`).
 * Este es el ÚNICO módulo que emite queries Supabase para bloqueos.
 */

/**
 * Bloqueos con `fecha >= from`, ordenados por fecha y luego created_at.
 *
 * Si Supabase no está configurado devuelve `[]` — misma degradación que
 * `fetchUpcoming` en reservations.repository.js.
 * @param {{ from: string }} params fecha ISO (YYYY-MM-DD), límite inferior inclusive
 * @returns {Promise<Array<object>>}
 * @throws {Error} si Supabase responde con error
 */
export async function listBlocks({ from }) {
    const client = getSupabaseClient();
    if (!client) return [];

    const { data, error } = await client
        .from('availability_blocks')
        .select('*')
        .gte('fecha', from)
        .order('fecha', { ascending: true })
        .order('created_at', { ascending: true });

    if (error) throw new Error(error.message);
    return data ?? [];
}

/**
 * Inserta un bloqueo nuevo. Momento y área pueden ser `null` (bloquea todo el
 * día / todas las áreas, respectivamente).
 * @param {{ fecha: string, momento?: string|null, area?: string|null, reason: string }} input
 * @returns {Promise<object>} la fila creada
 * @throws {Error} si Supabase no está configurado o la query falla
 */
export async function createBlock({ fecha, momento, area, reason }) {
    const client = getSupabaseClient();
    if (!client) throw new Error('Creación no disponible');

    const { data, error } = await client
        .from('availability_blocks')
        .insert({ fecha, momento, area, reason })
        .select()
        .single();

    if (error) throw new Error(error.message);
    return data;
}

/**
 * Elimina un bloqueo por id.
 * @param {string} id
 * @returns {Promise<void>}
 * @throws {Error} si Supabase no está configurado o la query falla
 */
export async function deleteBlock(id) {
    const client = getSupabaseClient();
    if (!client) throw new Error('Eliminación no disponible');

    const { error } = await client
        .from('availability_blocks')
        .delete()
        .eq('id', id);

    if (error) throw new Error(error.message);
}
